/* VOSTA homepage: tabbed hero (a video slide plays through, others stay data-dwell seconds), build-your-setup chips, the saved car's adapter.
   V1.1 (13/10/2026): hero and setup are separate editor sections ([data-vhero], [data-vsetup]) and re-init when edited in the theme editor.
   Loads after vosta-shell.js (car, A). */
(() => {
  const $$ = (s, r) => [...r.querySelectorAll(s)];

  /* ---------- hero ---------- */
  const initHero = hero => {
    if (hero._t) clearTimeout(hero._t);
    const slides = $$('.slide', hero), copies = $$('.hc', hero), tabs = $$('#herotabs button', hero);
    if (!slides.length) return;
    let cur = 0;
    const vid = i => $$('.r1v', slides[i]).find(v => getComputedStyle(v).display !== 'none');
    const go = i => {
      cur = i;
      [slides, copies, tabs].forEach(set => set.forEach(n => n.classList.toggle('on', +n.dataset.i === i)));
      hero.classList.toggle('is4', slides[i].hasAttribute('data-four'));
      slides.forEach((sl, j) => { const v = vid(j); if (v) { if (j === i) { v.currentTime = 0; v.play().catch(() => {}); } else v.pause(); } });
    };
    const tick = () => { clearTimeout(hero._t); hero._t = setTimeout(next, (+slides[cur].dataset.dwell || 6.5) * 1000); };
    const next = () => { go((cur + 1) % slides.length); tick(); };
    hero._go = i => { go(i); tick(); };
    tabs.forEach(b => b.onclick = () => hero._go(+b.dataset.i));
    slides.forEach((sl, j) => $$('.r1v', sl).forEach(v => v.addEventListener('ended', () => { if (cur === j && getComputedStyle(v).display !== 'none') next(); })));
    /* lazy slides: load their images now so the crossfade has something to show */
    $$('.slide img[loading="lazy"]', hero).forEach(im => setTimeout(() => im.loading = 'eager', 1500));
    go(0); tick();
  };

  /* ---------- build your setup ---------- */
  const initSetup = box => {
    const first = box.querySelector('#setchips .chip');
    let set = first ? first.dataset.set : '';
    const drawSet = () => {
      const c = car(), want = !c ? A + 'nissan-skyline-r34' : c.a === A + 'universal' ? null : c.a; /* universal cars: the universal card is already there */
      $$('#setchips .chip', box).forEach(b => b.classList.toggle('on', b.dataset.set === set));
      $$('#setgrid .card', box).forEach(n => {
        n.hidden = n.dataset.set !== set || (n.dataset.carad !== undefined && n.dataset.carad !== want);
      });
    };
    box.querySelector('#setchips').onclick = e => { const b = e.target.closest('[data-set]'); if (b) { set = b.dataset.set; drawSet(); } };
    if (!box._car) { box._car = 1; document.addEventListener('carchange', drawSet); }
    drawSet();
  };

  const init = root => {
    $$('[data-vhero]', root).forEach(initHero);
    $$('[data-vsetup]', root).forEach(initSetup);
  };
  init(document);
  /* theme editor: re-run on the section that changed; selecting a slide block shows that slide */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const hero = e.target.closest('[data-vhero]'), i = e.target.dataset.i;
    if (hero && hero._go && i !== undefined) { hero._go(+i); clearTimeout(hero._t); }
  });
})();

/* ---------- 4WD homepage: make chips → vehicle tiles; picking one saves it and opens the touring seats ---------- */
(() => {
  const h4 = document.querySelector('[data-v4home]');
  if (!h4) return;
  const vmk = h4.querySelector('#vmk'), veh = h4.querySelector('#veh');
  let mk = null;
  const draw = () => {
    const all = CARS.filter(c => c.fourby), sv = all.find(c => c.id === carId);
    if (!mk && sv) mk = sv.mk;
    const mks = [...new Set(all.map(c => c.mk))].sort((a, b) => a.localeCompare(b));
    vmk.innerHTML = mks.map(m => `<button type="button" data-vmk="${esc(m)}" class="${m === mk ? 'on' : ''}">${esc(m)}</button>`).join('') + `<a href="${U.measure}?new=1" class="vnl">Not listed? Measure yours, get ${MEASURE_REWARD}</a>`;
    veh.innerHTML = !mk ? '' : all.filter(c => c.mk === mk).map(c => {
      const uni = !c.a || c.a === A + 'universal';
      return `<button type="button" data-v="${c.id}" class="${c.id === carId ? 'on' : ''}"><b>${esc(c.md)}</b><span class="vch">${esc(c.ch || '')}${c.ch && c.y ? ' · ' : ''}${esc(c.y || '')}</span><small>${uni ? 'Universal adapter · ADR approved as supplied*' : 'Vehicle-specific adapter · bolts straight in'}</small></button>`;
    }).join('');
  };
  vmk.onclick = e => { const b = e.target.closest('[data-vmk]'); if (b) { mk = b.dataset.vmk; draw(); } };
  veh.onclick = e => { const b = e.target.closest('[data-v]'); if (!b) return; carId = b.dataset.v; ls.set('vosta-car', carId); location.href = U.fourbySeats; };
  document.addEventListener('carchange', draw);
  draw();
})();
